<template>
    <u-txt-medium v-bind="$attrs" :class="color"><slot /></u-txt-medium>
</template>

<script>
import UTxtMedium from "@/components/publish/styles/typography/u-txt-medium.vue";

export default {
    props: {
        color: { type: String, default: "txt--dark" },
    },
    components: {
        UTxtMedium,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
